import React, { useState, useEffect } from "react";
import "./PopupQuestion.css";
import question from "../imagesHome/help.png";
import conti from "../imagesHome/conti.png";
import coinImg from "../header/images/coin.png";

const PopupQuestion = ({ quizExplanation, coinCount = 0, onRevealAnswer }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [showExplanation, setShowExplanation] = useState(false);
  const [answerRevealed, setAnswerRevealed] = useState(false);
  const [unlockingAnswer, setUnlockingAnswer] = useState(false);

  const openPopup = () => {
    if (isVisible && isOpen) return;
    setIsVisible(true);
    requestAnimationFrame(() => setIsOpen(true));
  };

  const closePopup = () => {
    if (!isVisible) return;
    setIsOpen(false);
    setShowExplanation(false);
    setAnswerRevealed(false);
    setUnlockingAnswer(false);
  };

  const handleShowExplanation = () => {
    setShowExplanation(true);
  };

  const handleAnswerUnlock = () => {
    // Selectează direct răspunsul corect fără a mai arăta panoul de confirmare
    console.log("handleAnswerUnlock called, onRevealAnswer:", onRevealAnswer);
    setAnswerRevealed(true);
    setShowExplanation(true);
    setUnlockingAnswer(false);
    onRevealAnswer?.();
    
    // Închide popupul cu o mică întârziere pentru a permite actualizării stării
    setTimeout(() => {
      closePopup();
    }, 100);
  };

  const handleConfirmAnswer = () => {
    setAnswerRevealed(true);
    setShowExplanation(true);
    setUnlockingAnswer(false);
    onRevealAnswer?.();
    closePopup();
  };

  useEffect(() => {
    if (!isVisible) return;

    const closeTimer = setTimeout(() => {
      if (!isOpen) {
        setIsVisible(false);
      }
    }, 280);

    return () => clearTimeout(closeTimer);
  }, [isVisible, isOpen]);

  useEffect(() => {
    if (isOpen) {
      document.body.classList.add("quiz-active");
      document.documentElement.classList.add("quiz-active");
    } else {
      document.body.classList.remove("quiz-active");
      document.documentElement.classList.remove("quiz-active");
    }

    return () => {
      document.body.classList.remove("quiz-active");
      document.documentElement.classList.remove("quiz-active");
    };
  }, [isOpen]);

  useEffect(() => {
    if (!isVisible) return;

    const onKeyDown = (event) => {
      if (event.key === "Escape") {
        closePopup();
      }
    };

    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [isVisible]);

  return (
    <div className="popup-question-container">
      <button
        type="button"
        className="oriented-question-track"
        onClick={isOpen ? closePopup : openPopup}
        aria-label="Deschide ajutor"
      >
        <img src={question} className="question-popup-icon" alt="Ajutor" />
      </button>

      {isVisible && (
        <>
          <div className={`popup-question-overlay ${isOpen ? "open" : ""}`} onClick={closePopup} />
          <div
            className={`popup-question ${isOpen ? "open" : ""}`}
            role="dialog"
            aria-modal="true"
            aria-label="Ajutor pentru lecție"
          >
            <button className="popup-question-close" onClick={closePopup}>
              ×
            </button>
            <div className="popup-question-content">
              {unlockingAnswer ? (
                <div className="popup-question-unlock-view">
                  <img src={coinImg} className="popup-question-unlock-coin" alt="monede" />
                  <h3 className="popup-question-unlock-title">Obții răspunsul</h3>
                  <p className="popup-question-unlock-subtitle">Folosește monedele tale pentru a vedea răspunsul corect.</p>
                  <p className="popup-question-unlock-balance">
                    <img src={coinImg} className="popup-coin-icon" alt="coins" /> Sold: {coinCount}
                  </p>
                  <button
                    className="popup-question-btn popup-question-btn--answer"
                    onClick={handleConfirmAnswer}
                  >
                    <span className="popup-question-btn-label">Deblochez pentru</span>
                    <span className="popup-question-btn-price">
                      <img src={coinImg} className="popup-coin-icon" alt="coins" /> 30
                    </span>
                  </button>
                  <button
                    className="popup-question-unlock-cancel"
                    onClick={() => setUnlockingAnswer(false)}
                  >
                    Anulează
                  </button>
                </div>
              ) : (
                <>

                 <div className="popup-question-coins-info">
                    <img src={coinImg} className="popup-coin-icon" alt="coins" />
                    <span>Sold: {coinCount}</span>
                  </div>

                  <div className="popup-question-mascot">
                    <img src={conti} className="popup-question-conti" alt="Conti" />
                    <div className="popup-question-bubble">
                      {showExplanation ? (
                        <div
                          className="popup-question-explanation-content"
                          dangerouslySetInnerHTML={{
                            __html: quizExplanation || "<p>Explicația nu este disponibilă pentru acest quiz.</p>"
                          }}
                        />
                      ) : (
                        <p>Ai ramas blocat?</p>
                      )}
                    </div>
                  </div>
                 
                  <div className="popup-question-btns">
                    {!answerRevealed && !showExplanation && (
                      <button
                        className="popup-question-btn popup-question-btn--hint"
                        onClick={handleShowExplanation}
                      >
                        <span className="popup-question-btn-label">Vezi explicatia</span>
                        <span className="popup-question-btn-price">
                          
                          <img src={coinImg} className="popup-coin-icon" alt="coins" />
                          20
                        </span>
                      </button>
                    )}
                    {!answerRevealed && (
                      <button
                        className="popup-question-btn popup-question-btn--answer"
                        onClick={handleAnswerUnlock}
                      >
                        <span className="popup-question-btn-label">Vezi raspunsul</span>
                        <span className="popup-question-btn-price">
                          
                          <img src={coinImg} className="popup-coin-icon" alt="coins" />
                          30
                        </span>
                      </button>
                    )}
                  </div>
                </>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default PopupQuestion;
